var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "points icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "starOne",
    className: "starOneIcon",
    d: "M7.07892 2.12715C7.39 1.29095 8.61 1.29095 8.92108 2.12715L9.99536 5.01491C10.1315 5.3808 10.4841 5.62915 10.8852 5.64157L14.0505 5.73957C14.967 5.76795 15.344 6.89266 14.6197 7.43783L12.1184 9.32057C11.8014 9.55912 11.6667 9.96096 11.7785 10.3345L12.6605 13.2829C12.9159 14.1366 11.9289 14.8317 11.1701 14.3324L8.54994 12.6083C8.21795 12.3898 7.78205 12.3898 7.45006 12.6083L4.82987 14.3324C4.07115 14.8317 3.08414 14.1366 3.33953 13.2829L4.22151 10.3345C4.33326 9.96096 4.19856 9.55912 3.88163 9.32057L1.38028 7.43783C0.655979 6.89266 1.03298 5.76795 1.94954 5.73957L5.11482 5.64157C5.51588 5.62915 5.86853 5.3808 6.00464 5.01491L7.07892 2.12715Z",
    fill: "white",
    stroke: "#EAAA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "starTwo",
    d: "M6.07892 3.12715C6.39 2.29095 7.61 2.29095 7.92108 3.12715L8.99536 6.0149C9.13147 6.3808 9.48412 6.62915 9.88518 6.64157L13.0505 6.73957C13.967 6.76795 14.344 7.89266 13.6197 8.43783L11.1184 10.3206C10.8014 10.5591 10.6667 10.961 10.7785 11.3345L11.6605 14.2829C11.9159 15.1366 10.9289 15.8317 10.1701 15.3324L7.54994 13.6083C7.21795 13.3898 6.78205 13.3898 6.45006 13.6083L3.82987 15.3324C3.07115 15.8317 2.08414 15.1366 2.33953 14.2829L3.22151 11.3345C3.33326 10.961 3.19856 10.5591 2.88163 10.3206L0.380285 8.43783C-0.344021 7.89266 0.032982 6.76795 0.949542 6.73957L4.11482 6.64157C4.51588 6.62915 4.86853 6.3808 5.00464 6.0149L6.07892 3.12715Z",
    fill: "#EAAA00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.e1816f28f0e1500b42b7cbe0ceb4054e.svg";
export { ForwardRef as ReactComponent };